import Swiper, { EffectFade, Autoplay, Navigation } from "swiper";
import { pauseAnimation, resumeAnimation, isAnimationStopped } from "../../../../assets/scripts/extends/cookiesManager";

const testimonialsCarousel3Options = {
  modules: [EffectFade, Autoplay, Navigation],
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  autoHeight: true,
  navigation: {
    nextEl: ".testimonials-carousel-3 .next",
    prevEl: ".testimonials-carousel-3 .prev",
  },
};

if (!isAnimationStopped()) {
  testimonialsCarousel3Options.autoplay = {
    delay: 5000,
  };
}

const testimonialsCarousel_3 = new Swiper(".testimonials-carousel-3 .swiper", testimonialsCarousel3Options);
